import { CIcon } from '~/icons/types'

export const ciRoadBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M19.298 10.359a4.278 4.278 0 0 0-1.176.182l-1.458-4.09h2.738a.397.397 0 0 1-.057.161.456.456 0 0 1-.283.152 2.445 2.445 0 0 1-.587.007.49.49 0 0 0-.532.466.5.5 0 0 0 .466.532 3.262 3.262 0 0 0 .847-.025 1.422 1.422 0 0 0 .916-.57 1.87 1.87 0 0 0 .219-1.275.5.5 0 0 0-.498-.449h-3.938a.5.5 0 0 0-.471.668l.727 2.043-7.308.092-.992-2.278.456.002h.002a.5.5 0 0 0 .001-1l-2.32-.008h-.002a.5.5 0 0 0-.002 1l.773.003 1.058 2.43a.489.489 0 0 0-.1.098l-1.359 2.216a4.34 4.34 0 1 0 2.57 4.48h1.018a1.296 1.296 0 0 0 1.077.6 1.327 1.327 0 0 0 1.33-1.32 1.235 1.235 0 0 0-.037-.182l4.58-4.042.24.674a4.303 4.303 0 1 0 2.102-.567Zm-10.95-.877 1.78 4.087a1.319 1.319 0 0 0-.309.627h-.831a4.314 4.314 0 0 0-1.71-2.97Zm-.36 4.714h-2.53l1.295-2.112a3.318 3.318 0 0 1 1.235 2.112Zm-3.286 3.835a3.336 3.336 0 0 1 0-6.672 3.303 3.303 0 0 1 1.183.227L4.14 14.435a.5.5 0 0 0 .426.761h3.423a3.332 3.332 0 0 1-3.286 2.835Zm7.15-4.609a1.295 1.295 0 0 0-.769-.277c-.016 0-.03.01-.045.01L9.336 9.247l7.19-.09.037.108Zm7.446 4.61a3.329 3.329 0 0 1-1.763-6.157l1.065 2.99a.501.501 0 0 0 .472.332.483.483 0 0 0 .168-.029.5.5 0 0 0 .303-.639l-1.087-3.05a3.296 3.296 0 0 1 .842-.12 3.336 3.336 0 0 1 0 6.672Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'road-bike',
  type: 'thin'
}
